// import format from "date-fns/format";
// import getDay from "date-fns/getDay";
// import parse from "date-fns/parse";
// import startOfWeek from "date-fns/startOfWeek";

import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";


import React, { useState, useEffect } from "react";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import {
  Calendar,
  // dateFnsLocalizer,
  momentLocalizer,
} from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import moment from "moment";
import "moment-timezone"; // or 'moment-timezone/builds/moment-timezone-with-data[-datarange].js'. See their docs

import RecordsDashboard from "./RecordsDashboard";

// Set the IANA time zone you want to use
moment.tz.setDefault("Nairobi/Kenya");

// Setup the localizer by providing the moment Object
// to the correct localizer.
const localizer = momentLocalizer(moment); // or globalizeLocalizer



let events = [

];

function RecordsCalender() {
  const [newEvent, setNewEvent] = useState({ title: "", start: "", end: "" });
  // const [allEvents, setAllEvents] = useState(events);
  const [allEvents, setAllEvents] = useState(events);

  // const [eventsAI, setEventsAI] = useState([]);

  function handleAddEvent() {
    for (let i = 0; i < allEvents.length; i++) {
      const d1 = new Date(allEvents[i].start);
      const d2 = new Date(newEvent.start);
      const d3 = new Date(allEvents[i].end);
      const d4 = new Date(newEvent.end);
      /*
          console.log(d1 <= d2);
          console.log(d2 <= d3);
          console.log(d1 <= d4);
          console.log(d4 <= d3);
            */

      if ((d1 <= d2 && d2 <= d3) || (d1 <= d4 && d4 <= d3)) {
        alert("CLASH");
        break;
      }
    }

    // setAllEvents([...allEvents, newEvent]);

    //refresh data
    refreshRecords();
  }

  const [foundErr, setFoundErr] = useState(null);

  const [isLoading, setIsLoading] = useState(null);

  const [records, setRecords] = useState([]);
  const [downloadPeriod, setDownloadPeriod] = useState("full");

  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(new Date());


  useEffect(() => {
    //fetch agents
    const fetchAll = () => {
      let adminCookie = Cookies.get("sessioniduser");
      if (adminCookie.length >= 1) {
        setIsLoading(true);

        setTimeout(() => {
          fetch("https://api.terraweb.africa/getRecords", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              userid: adminCookie,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user[0].id >= 1) {
                //load data

                setFoundErr(null);

                setIsLoading(null);

                //new way to update the state event without duplicates
                // Update events using setEvents, excluding duplicates
                setAllEvents((prevEvents) => {
                  const updatedEvents = [...prevEvents];

                  for (const val of user) {
                    const eventExists = updatedEvents.some(
                      (event) => event.id === val.id
                    );

                    if (!eventExists) {
                      updatedEvents.push({
                        id: val.id,
                        title: val.weight + " - " + val.producttype,
                        allday: true,
                        start: new Date(val.daterecorded),
                        end: new Date(val.daterecorded),
                      });
                    }
                  }

                  return updatedEvents;
                });

                setRecords(user);

              } else {
                //dont load

                setFoundErr(null);
                setIsLoading(null);
              }
            })
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 2000);
      } else {
        setIsLoading(null);
      }
    };

    fetchAll();
  }, []);



  //fetch records
  const fetchRecords = () => {
    let adminCookie = Cookies.get("sessioniduser");
    if (adminCookie.length >= 1) {
      setIsLoading(true);

      setTimeout(() => {
        fetch("https://api.terraweb.africa/getRecords", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            userid: adminCookie,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].id >= 1) {
              //load data

              setFoundErr(null);

              setIsLoading(null);

              //new way of updating allevents without duplicates
              // Update events using setEvents, excluding duplicates
              setAllEvents((prevEvents) => {
                const updatedEvents = [...prevEvents];

                for (const val of user) {
                  const eventExists = updatedEvents.some(
                    (event) => event.id === val.id
                  );

                  if (!eventExists) {
                    updatedEvents.push({
                      id: val.id,
                      title: val.weight + " - " + val.producttype,
                      allday: true,
                      start: new Date(val.daterecorded),
                      end: new Date(val.daterecorded),
                    });
                  }
                }

                return updatedEvents;
              });

              setRecords(user);
            } else {
              //dont load

              setFoundErr(null);
              setIsLoading(null);
            }

          })
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 5000);
    } else {
      setIsLoading(null);
    }
  };

  //refresh after add records
  const refreshRecords = () => {
    fetchRecords();
  };

  const handleDownloadTable = () => {
    const filteredRecords = getFilteredRecords();

    if (filteredRecords.length === 0) {
      alert("No records found for selected period");
      return;
    }

    const doc = new jsPDF();

    const currentDate = new Date().toLocaleString();

    // Header
    doc.setFontSize(16);
    doc.text("Terraweb.africa", 14, 15);

    doc.setFontSize(11);
    doc.text("Empowering farmers through technology", 14, 22);

    doc.setFontSize(10);
    doc.text(`Generated on: ${currentDate}`, 14, 28);

    // Table columns
    const tableColumn = [
      "ID",
      "Farmer ID",
      "Product Type",
      "Weight",
      "Company",
      "Full Name",
      "Recorded",
    ];

    // Table rows
    const tableRows = filteredRecords.map((contact) => [
      contact.id,
      contact.farmerid,
      contact.producttype,
      contact.weight,
      contact.companyname,
      contact.fullname,
      contact.daterecorded,
    ]);

    autoTable(doc, {
      head: [tableColumn],
      body: tableRows,
      startY: 35,
      styles: {
        fontSize: 9,
        textColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [252, 156, 28],
      },
      margin: {
        top: 35,
        bottom: 20,
      },

      didDrawPage: function (data) {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFontSize(9);

        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
          data.settings.margin.left,
          doc.internal.pageSize.height - 10
        );

        doc.text(
          "© Terraweb.africa — All rights reserved.",
          data.settings.margin.left + 70,
          doc.internal.pageSize.height - 10
        );
      },
    });
    const timestamp = new Date()
      .toISOString()
      .replace(/[:.]/g, "-");

    doc.save(`terraweb-farmerdata-${timestamp}.pdf`);
  };


  const getFilteredRecords = () => {
    if (downloadPeriod === "full") {
      return records;
    }

    return records.filter((record) => {
      const recordDate = new Date(record.daterecorded);

      // return (
      //   customStartDate &&
      //   customEndDate &&
      //   recordDate >= customStartDate &&
      //   recordDate <= customEndDate
      // );


      return (
        customStartDate &&
        customEndDate &&
        recordDate >= customStartDate &&
        recordDate <= new Date(customEndDate.setHours(23, 59, 59, 999))
      );
    });
  };

  return (
    <div className="Apppp bg-white pa4 mt6 w-80-l center">
      {/* PAGE HEADER */}


      {/* FILTER + ACTIONS SECTION */}
      <div className="bg-near-white br4 shadow-2 pa4 mb5">
        <div className="mb4">
          <h1 className="f2 fw7 dark-gray ma0">
            Hi, your records
          </h1>


          <p className="gray mt2 mb0 f5 lh-copy">
            View, filter and export your daily farmer collection records. 
          </p>
        </div>
  
        {/* stats section */}

        <RecordsDashboard />


 {/* LOADER */}
            {isLoading ? (
              <div className="mt3">
                <Circles
                  type="Oval"
                  color="#1b1b1b"
                  height={40}
                  width={40}
                />
              </div>
            ) : null}

            {/* ERROR */}
            {foundErr ? (
              <label className="db red mt3 fw6">
                {foundErr}
              </label>
            ) : null}

      </div>
      <Calendar
        localizer={localizer}
        events={allEvents}
        startAccessor="start"
        endAccessor="end"
        style={{
          height: 550,
          marginTop: "20px",
          backgroundColor: "white",
          padding: "10px",
          borderRadius: "12px",
        }}
      />

      <div className="bg-near-white br4 shadow-2 pa4 mb5">


 {/* TOP GRID */}
        <div className="flex flex-column flex-row-l justify-between items-start">

          {/* LEFT SIDE */}
          <div className="w-100 w-70-l">

            <h2 className="f4 fw6 dark-gray mt0 mb4">
              Record Retrieval & Export
            </h2>

            {/* FILTER CONTROLS */}
            <div className="flex flex-column flex-row-l flex-wrap items-start">

              {/* CALENDAR START DATE */}
              <div className="mr3 mb3">
                <label className="db mb2 fw6 gray f6">
                  Calendar Start Date
                </label>

                <DatePicker
                  placeholderText="Start Date"
                  selected={newEvent.start}
                  onChange={(start) =>
                    setNewEvent({ ...newEvent, start })
                  }
                  className="
              pa2
              br3
              ba
              b--light-silver
              bg-white
              dark-gray
              outline-0
              w5
            "
                />
              </div>

              {/* CALENDAR END DATE */}
              <div className="mr3 mb3">
                <label className="db mb2 fw6 gray f6">
                  Calendar End Date
                </label>

                <DatePicker
                  placeholderText="End Date"
                  selected={newEvent.end}
                  onChange={(end) =>
                    setNewEvent({ ...newEvent, end })
                  }
                  className="
              pa2
              br3
              ba
              b--light-silver
              bg-white
              dark-gray
              outline-0
              w5
            "
                />
              </div>

              {/* REFRESH BUTTON */}
              <div className="mt4 mt0-l">
                <button
                  onClick={handleAddEvent}
                  className="
              pointer
              bn
              br-pill
              bg-orange
              white
              fw6
              pa3
              ph4
              shadow-1
              hover-bg-dark-orange
              dim
              transition
            "
                >
                  🔄 Refresh Records
                </button>
              </div>
            </div>

            {/* LOADER */}
            {isLoading ? (
              <div className="mt3">
                <Circles
                  type="Oval"
                  color="#1b1b1b"
                  height={40}
                  width={40}
                />
              </div>
            ) : null}

            {/* ERROR */}
            {foundErr ? (
              <label className="db red mt3 fw6">
                {foundErr}
              </label>
            ) : null}
          </div>

        </div>
              {/* DIVIDER */}
        <div className="bt b--black-10 mv4"></div>
        {/* DOWNLOAD SECTION */}
        <div className="flex flex-column flex-row-l items-start items-end-l justify-between">

          {/* LEFT SIDE */}
          <div className="w-100 w-70-l">

            <h3 className="f4 fw6 near-black ma0 mb3">
              Download Farmer Records
            </h3>

            <div className="flex flex-column flex-row-l flex-wrap items-start">

              {/* PERIOD SELECT */}
              <div className="mr3 mb3">
                <label className="db mb2 fw6 gray f6">
                  Export Period
                </label>

                <select
                  className="
              pa2
              br3
              ba
              b--light-silver
              bg-white
              dark-gray
              outline-0
              w5
            "
                  value={downloadPeriod}
                  onChange={(e) =>
                    setDownloadPeriod(e.target.value)
                  }
                >
                  <option value="full">
                    Full Records
                  </option>

                  <option value="custom">
                    Custom Range
                  </option>
                </select>
              </div>

              {/* CUSTOM DATES */}
              {downloadPeriod === "custom" && (
                <>
                  {/* FROM */}
                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">
                      From
                    </label>

                    <DatePicker
                      selected={customStartDate}
                      onChange={(date) =>
                        setCustomStartDate(date)
                      }
                      placeholderText="Start Date"
                      className="
                  pa2
                  br3
                  ba
                  b--light-silver
                  bg-white
                  dark-gray
                  outline-0
                  w5
                "
                    />
                  </div>

                  {/* TO */}
                  <div className="mr3 mb3">
                    <label className="db mb2 fw6 gray f6">
                      To
                    </label>

                    <DatePicker
                      selected={customEndDate}
                      onChange={(date) =>
                        setCustomEndDate(date)
                      }
                      placeholderText="End Date"
                      className="
                  pa2
                  br3
                  ba
                  b--light-silver
                  bg-white
                  dark-gray
                  outline-0
                  w5
                "
                    />
                  </div>
                </>
              )}
            </div>
          </div>

          {/* DOWNLOAD BUTTON */}
          <div className="mt4 mt0-l">
            <button
              onClick={handleDownloadTable}
              className="
          pointer
          bn
          br-pill
          white
          bg-dark-green
          hover-bg-green
          pa3
          ph4
          fw6
          shadow-1
          dim
          transition
        "
            >
              ⬇ Download PDF
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RecordsCalender;
